import {isAtLeastMinimumAge, MINIMUM_PATIENT_AGE} from '@common/utils'

import {isEmailValid} from '~/utils/general'
import {validatePhoneNumberInput} from '~/utils/phoneValidation'

export type BookingFormValues = {
  firstName: string
  secondName: string
  email: string
  phone: string
  dateOfBirth: string
}

export const isBookingDetailsFormValid = (form: BookingFormValues): boolean => {
  const emailOk = isEmailValid(form.email) && !!form.email.trim()
  const phoneValidation = validatePhoneNumberInput(form.phone, {required: true})
  const dateOfBirthOk = isAtLeastMinimumAge(
    form.dateOfBirth,
    MINIMUM_PATIENT_AGE,
  )

  return (
    !!form.firstName.trim() &&
    !!form.secondName.trim() &&
    emailOk &&
    phoneValidation.isValid &&
    dateOfBirthOk
  )
}
